exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".page-home{background:#fff}@media (max-width:320px){.connect-us-cont .contact-copyright,.connect-us-cont .contact-us{font-size:.32rem}.connect-us-cont .contact-us{padding-left:.37333rem}}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/home.vue"],"names":[],"mappings":"AACA,WACE,eAAiB,CAClB,AAED,yBACA,iEAEI,gBAAmB,CACtB,AACD,6BACI,sBAAyB,CAC5B,CACA","file":"home.vue","sourcesContent":["\n.page-home {\n  background: #fff;\n}\n/* 添加媒体查询，针对iphone5以下小屏设备样式 */\n@media (max-width: 320px) {\n.connect-us-cont .contact-us,\n  .connect-us-cont .contact-copyright {\n    font-size: 0.32rem;\n}\n.connect-us-cont .contact-us {\n    padding-left: 0.37333rem;\n}\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a26bffc","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/home/home.vue
// module id = 9RS9
// module chunks = 0